import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { InvitationProvider } from '@modeso/aumico-lib-users-fe';
import { Observable, filter, map, startWith } from 'rxjs';
import { Paths } from '../../enums/paths.enum';
import { localizationKeys } from '../../utils/localizationKeys';

@Component({
    selector: 'app-auth',
    template: ` <aumico-intro-layout [showBackButton]="showBackButton$ | async">
        <router-outlet></router-outlet>

        <div aumico-intro-layout-side-content>
            <app-side-heading *ngIf="inviterName$ | async as inviterName; else introText">
                {{
                    localizationKeys.aumico_reports_invitation_intro | i18next | replace : '{inviterName}' : inviterName
                }}
            </app-side-heading>
            <ng-template #introText> </ng-template>
            <app-side-paragraph style="margin-top: 20px; margin-bottom: 20px; display: none">
                {{ localizationKeys.aumico_reports_login_introduction | i18next }}
            </app-side-paragraph>
        </div>
        <div aumico-intro-footer>
            <ng-content select="[aumico-intro-footer]"></ng-content>
        </div>
    </aumico-intro-layout>`,
})
export class AuthModulePage {
    localizationKeys = localizationKeys;
    inviterName$: Observable<string>;
    showBackButton$: Observable<boolean>;

    constructor(private readonly invitationProvider: InvitationProvider, private readonly router: Router) {
        this.inviterName$ = this.invitationProvider
            .getInvitation$()
            .pipe(map((invitation) => (invitation ? invitation.inviterName : null)));

        // Hide back button only on login page
        this.showBackButton$ = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map((event: NavigationEnd) => {
                // Check if current URL ends with 'login' (handles language prefix like /de-ch/auth/login)
                return !event.url.endsWith(`/${Paths.LOGIN}`);
            }),
            startWith(!this.router.url.endsWith(`/${Paths.LOGIN}`)), // Initial value
        );
    }
}
